// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__35sr5","header":"ClearentDisclaimer_header__2sp4J","inner":"ClearentDisclaimer_inner__VcV9u"};